import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import GoalInput from "./GoalInput";

const ConnectedGoalInput = ({
    id,
    name = "",
    allowsZeroDollarValue = false,
}) => {
    const settings = useSelector(selectAllFormSettings);
    const goalInputProps = {
        id,
        name,
        settings,
        allowsZeroDollarValue,
    };
    return <GoalInput {...goalInputProps} />;
};

ConnectedGoalInput.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    allowsZeroDollarValue: PropTypes.bool,
};

export default ConnectedGoalInput;
